// This function allow to reference all chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"96":"vendors","159":"vendor-maps","182":"vendor-i18n","514":"vendor-recharts","792":"main","967":"vendor-react"}[chunkId] || chunkId) + ".bundle.js";
};